import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AwarenessTagManagerEvents } from "../../utils/GoogeTagManager";
import { sha256Hash } from "../../utils/CommonFunction";
import { setCookie } from "../../utils/CommonFunction";

import SubscriptionSuccesPopUp from "../../components/SubscriptionSuccesPopUp";
import Loader from "../../components/Loader";

import FailurePopUp from "../../components/FailurePopUp";
// import Loader from "../../components/Common/CustomLoader";
const JazzCashFallbackScreen = () => {
  const navigate = useNavigate();
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  const status = searchParams.get("status") ? searchParams.get("status") : "1";
  const message = searchParams.get("message")
    ? searchParams.get("message")
    : "";
  const plan_id = searchParams.get("plan_id")
    ? searchParams.get("plan_id")
    : "1";
  const token = searchParams.get("token") ? searchParams.get("token") : "";
  const msisdn = searchParams.get("msisdn") ? searchParams.get("msisdn") : "";
  const utm_source = searchParams.get("utm_source")
    ? searchParams.get("utm_source")
    : "";

  const [loading, setLoading] = useState(true);

  const [showJazzCashFailurePoUp, setShowJazzCashFailurePopUp] =
    useState<boolean>(false);

  const [showJazzCashSuccessPopUp, setShowJazzCashSuccessPopUp] =
    useState(false);

  useEffect(() => {
    console.log("run", status);
    console.log(typeof status, message, token, msisdn);
    if (status === "0") {
      if (utm_source) {
        if (msisdn) {
          AwarenessTagManagerEvents({
            event: "subscribe_jazzcash",
            utm_source: utm_source,
            plan_id: plan_id,
            phone_number: sha256Hash("+92" + msisdn?.slice(-10)),
            external_id: sha256Hash("jhoom" + msisdn?.slice(-10)),
            plainNumber: msisdn?.slice(-10),
          });
        } else {
          AwarenessTagManagerEvents({
            event: "subscribe_jazzcash",
            utm_source: utm_source,
            plan_id: plan_id,
          });
        }
      }
      setTimeout(() => {
        setLoading(false);
        console.log(">>>>>>>>>>>>> poup for success");
        if (msisdn) {
          setCookie(msisdn.slice(-10), token);
        }
        setShowJazzCashSuccessPopUp(true);
      }, 1200);
    } else {
      console.log("else case if status is 1:: ===>>", status);
      setLoading(false);
      setShowJazzCashFailurePopUp(true);
    }
  }, []);

  const hideFailureJazzCashPopUp = () => {
    setShowJazzCashFailurePopUp(false);
    // navigate(RouteNames.home);
    window.location.replace("/home");
  };

  const onHidejcSuccessModal = () => {
    setShowJazzCashSuccessPopUp(false);
    // navigate(RouteNames.home);
    window.location.replace("/home");
  };

  if (loading) {
    return <Loader fullScreen />;
  }
  return (
    <div style={styles.background}>
      {showJazzCashSuccessPopUp && (
        <SubscriptionSuccesPopUp onHidejcSuccessModal={onHidejcSuccessModal} />
      )}
      {showJazzCashFailurePoUp && (
        <FailurePopUp
          message={message ?? ""}
          onClose={hideFailureJazzCashPopUp}
        />
      )}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  background: {
    minHeight: "100vh",
    width: "100%",
    background:
      "linear-gradient(135deg, #0d0d1f 0%, #1a1a3e 60%, #0d0d1f 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default JazzCashFallbackScreen;
